import { useWrite } from '@bw/hookshot';
import config from 'utils/config';

type UseRegisterAccount = {
  input: {
    phoneNumber: string;
    email: string;
    firstName: string;
    lastName: string;
  };
};

export interface SendRegisterAccount {
  message: string;
  status: string;
  registrationId: string;
  registrationToken: string;
}

export const useRegisterAccount = () => {
  return useWrite<UseRegisterAccount, SendRegisterAccount>(
    `${config.expressApi}/register`,
    'POST',
    {
      requestFormat: 'json',
      fetchOptions: {
        headers: {
          /* eslint-disable-next-line @typescript-eslint/naming-convention */
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    },
  );
};
